import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateTokenRequest, DeveloperApiToken, TenantLogEntry, TokenUsageEntry } from 'src/app/core/domain/developer-token.model';

/** Calls Portal.HttpFunctions' /api/developer/tokens (+ the sibling /api/developer/logs) —
 * JWT-authenticated (the logged-in user's own session), never token-authenticated. Tokens
 * manage themselves via login, not via a token (docs/KONZEPT-Developer-Platform.md). */
@Injectable({ providedIn: 'root' })
export class TokenApiService {
  private readonly base = `${environment.apiUrl}/developer/tokens`;
  private readonly logsUrl = `${environment.apiUrl}/developer/logs`;

  constructor(private http: HttpClient) { }

  list(): Observable<DeveloperApiToken[]> {
    return this.http.get<DeveloperApiToken[]>(this.base);
  }

  getById(id: string): Observable<DeveloperApiToken> {
    return this.http.get<DeveloperApiToken>(`${this.base}/${id}`);
  }

  usage(id: string): Observable<{ items: TokenUsageEntry[] }> {
    return this.http.get<{ items: TokenUsageEntry[] }>(`${this.base}/${id}/usage`);
  }

  create(req: CreateTokenRequest): Observable<DeveloperApiToken> {
    return this.http.post<DeveloperApiToken>(this.base, req);
  }

  revoke(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }

  logs(): Observable<{ items: TenantLogEntry[] }> {
    return this.http.get<{ items: TenantLogEntry[] }>(this.logsUrl);
  }
}
